var scope_0 = require('/home/runner/work/confluenza-action/confluenza-action/.prepare/confluenza/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_1 = require('/home/runner/work/confluenza-action/confluenza-action/.prepare/confluenza/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f4bdfaa827c81d5e7f1fa868e8d86fc7.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    